module.exports = __webpack_public_path__ + "img/miaoshu.6952b40f.png";